import type { IExportContextMenuItem } from '../type';
import { addImageItem } from './add-image-item';
import { saveToMySpaceItem } from './save-to-my-space-item';
import { showAllItem } from './show-all-item';

/** 内置 3 项；复制/剪切/粘贴见 clipboard；翻转/叠放等见 layer、group-layer */
export function getBuiltinContextMenuItems(): IExportContextMenuItem[] {
    return [
        {
            key: 'saveToMySpace',
            group: 1,
            sort: 1,
            render: saveToMySpaceItem,
        },
        {
            key: 'show-all',
            group: 1,
            sort: 1,
            render: showAllItem,
        },
        {
            key: 'addImage',
            group: 1,
            sort: 2,
            render: addImageItem,
        },
    ];
}
